import request from '@/utils/request'

// crm 新建客戶
export function crmCustomerSave(data) {
  return request({
    url: 'crm/customer/save',
    method: 'post',
    data: data
  })
}

// crm 客戶列表
export function crmCustomerIndex(data) {
  return request({
    url: 'crm/customer/index',
    method: 'post',
    data: data
  })
}

// 刪除
export function crmCustomerDelete(data) {
  return request({
    url: 'crm/customer/delete',
    method: 'post',
    data: data
  })
}

// crm 更新
export function crmCustomerUpdate(data) {
  return request({
    url: 'crm/customer/update',
    method: 'post',
    data: data
  })
}

// crm 公海列表
export function crmCustomerPool(data) {
  return request({
    url: 'crm/customer/pool',
    method: 'post',
    data: data
  })
}

// crm 詳情
export function crmCustomerRead(data) {
  return request({
    url: 'crm/customer/read',
    method: 'post',
    data: data
  })
}

// 操作
/**
 * 客戶鎖定，解鎖
 * @param {*} data
 * is_lock 1鎖定，2解鎖
 * customer_id 客戶陣列
 */
export function crmCustomerLock(data) {
  return request({
    url: 'crm/customer/lock',
    method: 'post',
    data: data
  })
}

/**
 * 客戶放入公海
 * @param {*} data
 * customer_id 	客戶陣列
 */
export function crmCustomerPutInPool(data) {
  return request({
    url: 'crm/customer/putInPool',
    method: 'post',
    data: data
  })
}

/**
 * 客戶轉移
 * @param {*} data
 * customer_id 	客戶陣列
 * owner_user_id 	變更負責人
 * is_remove 1移出，2轉為團隊成員
 * types business,contract 相關模組
 * type 許可權 1只讀2讀寫
 */
export function crmCustomerTransfer(data) {
  return request({
    url: 'crm/customer/transfer',
    method: 'post',
    data: data
  })
}

/**
 * 客戶導出
 * @param {*} data
 * customer_id 客戶ID
 */
export function crmCustomerExcelExport(data) {
  return request({
    url: 'crm/customer/excelExport',
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: 600000
  })
}

/**
 * 客戶匯入
 * @param {*} data
 * customer_id 客戶ID
 */
export function crmCustomerExcelImport(data) {
  var param = new FormData()
  Object.keys(data).forEach(key => {
    param.append(key, data[key])
  })
  return request({
    url: 'crm/customer/excelImport',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  })
}

/**
 * 客戶匯入模板下載
 * @param {*} data
 *
 */
export const crmCustomerExcelDownloadURL = 'crm/customer/excelDownload'


/**
 * 公海導出
 * @param {*} data
 */
export function crmCustomerPoolExcelExportAPI(data) {
  return request({
    url: 'crm/customer/poolExcelExport',
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: 600000
  })
}

/**
 * 客戶分配
 * @param {*} data
 * customer_id 客戶ID
 * owner_user_id 分配人ID
 */
export function crmCustomerDistribute(data) {
  return request({
    url: 'crm/customer/distribute',
    method: 'post',
    data: data
  })
}

/**
 * 客戶領取
 * @param {*} data
 * customer_id 客戶IDs
 */
export function crmCustomerReceive(data) {
  return request({
    url: 'crm/customer/receive',
    method: 'post',
    data: data
  })
}

/**
 * 客戶標記跟進
 * @param {*} data
 * id 客戶IDs
 */
export function crmCustomerSetFollowAPI(data) {
  return request({
    url: 'crm/customer/setFollow',
    method: 'post',
    data: data
  })
}

/**
 * 客戶成交狀態修改
 * @param {*} data
 * id 客戶IDs
 */
export function crmCustomerDealStatusAPI(data) {
  return request({
    url: 'crm/customer/deal_status',
    method: 'post',
    data: data
  })
}
